var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "32px",
    viewBox: "0 0 31 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Head") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Humanuculus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.195858829
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-8",
    transform: "translate(-73.000000, -42.000000)",
    fill: "#1E428A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.6361675,73.0195276 L100.1233,73.0195276 C100.622653,72.3535307 100.880601,71.8443932 100.897142,71.4921151 C101.041173,68.424741 100.569452,66.1084435 100.897142,64.8170147 C101.392799,62.8636289 102.542403,61.4597082 103.10768,60.1258073 C103.663307,58.8146774 103.640653,57.5642736 103.445633,56.7168244 C101.11006,46.5677003 95.2050333,44.3640855 89.9311766,42.7206283 C80.8185398,41.9521544 75.3607428,47.3616854 73.5577856,58.9492215 C74.77695,62.2174918 75.4471522,64.1734229 75.5683922,64.8170147 C75.783725,65.9600894 75.5675426,68.3226218 75.9332092,71.4921151 C75.9753301,71.8572072 76.2096496,72.3663447 76.6361675,73.0195276 Z",
    id: "Head"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHead);
export default __webpack_public_path__ + "static/media/Head.33286d0c7ed5aec74be0848fc36af5ad.svg";
export { ForwardRef as ReactComponent };